import { call, put } from "redux-saga/effects";
import Axios from "../../utils/axios";
import { setUserId, showErrorSnackbar } from "../../utils/util";
import { ACCOUNT_BY_ACCOUNT_ID } from "../../state/user/constants";
import { getAccountDone, loginError } from "../../state/user/actions";

function* getAccountByAccountId({ accountId }) {
  try {
    const url = ACCOUNT_BY_ACCOUNT_ID.replace(":accountId", accountId);
    const result = yield call(Axios.core.get, url);
    if (result?.data) {
      setUserId(result?.data.id);
    }
    yield put(getAccountDone(result?.data || {}));
  } catch (e) {
    yield put(loginError());
    const errorMessage = JSON.parse(e.request.response).message;
    showErrorSnackbar(errorMessage, {
      removeOnHover: false
    });
  }
}

export default getAccountByAccountId;
